<template>
  <div :class="btnClass">
    <a href="#">
      <table style="text-align: center; width: 100%">
        <tr style="width: 100%; line-height: 20px">
          <td style="vertical-align: middle; font-size: 20px; line-height: 50px">
            <slot></slot>
          </td>
        </tr>
      </table>
    </a>
  </div>
</template>
<script>
export default {
  name: "IconButton",
  data() {
    return {};
  },
  props: {
    icon: String,
    text: String,
    font: { String },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {},

  computed: {
    btnClass: function () {
      return this.selected ? "selected" : "no-selected";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  width: 100%;
  height: 49px;
  background-color: #44444c;
  color: #fff;
}
.disabled {
  color: gray;
}
.selected {
  border-left: 2px solid gray;
  border-top: 2px solid gray;
  border-right: 2px solid white;
  border-bottom: 2px solid white;
}
.no-selected {
  border: 2px solid gray;
}
a {
  text-decoration: none;
  color: white;
}
a:hover,
a:visited,
a:link,
a:active {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/IconButton.vue